import { render, staticRenderFns } from "./sendDialog.vue?vue&type=template&id=6194cf6f&scoped=true&"
import script from "./sendDialog.vue?vue&type=script&lang=js&"
export * from "./sendDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendDialog.vue?vue&type=style&index=0&id=6194cf6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6194cf6f",
  null
  
)

export default component.exports